import styled from 'styled-components';

const StyledHr = styled.hr`
  margin: 0.7rem 0;
  color: #1b02bd;
`;

export default StyledHr;
